import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { CreateMaintenanceWorkOrderDto, MaintenanceWorkOrder, UpdateMaintenanceWorkOrderDto } from '../models/maintenance-work-order';

@Injectable({ providedIn: 'root' })
export class MaintenanceWorkOrderProxyService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.proxyUrls.ascApi + '/api/v1/maintenance-work-order';

  getAll(): Observable<ApiResponse<MaintenanceWorkOrder[]>> {
    return this.httpClient.get<ApiResponse<MaintenanceWorkOrder[]>>(`${this.baseUrl}/all`);
  }

  getById(id: string): Observable<ApiResponse<MaintenanceWorkOrder>> {
    return this.httpClient.get<ApiResponse<MaintenanceWorkOrder>>(`${this.baseUrl}/${id}`);
  }

  create(dto: CreateMaintenanceWorkOrderDto): Observable<ApiResponse<MaintenanceWorkOrder>> {
    return this.httpClient.post<ApiResponse<MaintenanceWorkOrder>>(this.baseUrl, dto);
  }

  update(id: string, dto: UpdateMaintenanceWorkOrderDto): Observable<ApiResponse<MaintenanceWorkOrder>> {
    return this.httpClient.put<ApiResponse<MaintenanceWorkOrder>>(`${this.baseUrl}/${id}`, dto);
  }

  delete(id: string): Observable<ApiResponse<null>> {
    return this.httpClient.delete<ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}
